<script>
  import CloseButton from './CloseButton.svelte';
  import PopupGallery from './PopupGallery.svelte';
  import { createEventDispatcher, onMount } from 'svelte';
  import { fly, fade } from 'svelte/transition';
  export let visible = true;
  let scrollContainer;
  const dispatch = createEventDispatcher();
  function closePopup() {
    visible = false;
  }

  $: visible ? dispatch('open') : dispatch('close');

  $: if (visible) {
    onMount(() => {
      scrollContainer = document.querySelector('.content-inner');
      console.log(scrollContainer);
    })
  }
</script>

<style>
.popup {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  height: 100%;
}

.content {
  justify-content: center;
  font-family: 'Raleway', sans-serif;
  line-height: 1.5;
}

.content-inner {
  padding: 2rem;
  padding-top: 0;
  overflow-y: scroll;
  max-height: 80vh;
}

:global(.popup .content-inner a){
    color: #fff;
    font-weight: 700;
}

::-webkit-scrollbar {
 width: 10px;
}
::-webkit-scrollbar-thumb {
 background: #fff;
}

::-webkit-scrollbar-thumb:hover{
    background: #ddd;
}

.popup-area {
  position: fixed;
  z-index: 2001;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.popup-bg {
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.66);
}


.popup-window {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  max-width: 75%;
  max-height: 100%;
}

.popup-window-wrap {
  position: relative;
  margin: 2rem;
  max-height: 100%;
  box-sizing: border-box;
}

.popup-window {
  position: relative;
  width: 40rem;
  max-width: 100%;
  max-height: 100%;
  margin: 2rem auto;
  color: black;
  border-radius: 10px;
  background: var(--theme-color);
  color: rgb(255, 255, 255);
  width: 80%;
  overflow: hidden;
}

.popup-content {
  border-radius: 5px;
    padding: 0;
    height: 100%;
    width: 100%;
}

@media only screen and (max-width: 600px) {  
  .popup-area {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    
    width: 90%;
    height: 90%;
  }


  .popup-window-wrap, .popup-window {
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .popup-window {
    border-radius: none;
  }

  .column {
    width: 100%;
    flex: none;
  }

  .image.column {
    min-height: 40%;
    height: fit-content;
    aspect-ratio: 1/1;
  }

  .content.column {
  }

  .content {
    justify-content: flex-start;
  }

  .content-inner {
    font-size: 14px;
  }

  .popup-modal:not(.has-image) .content{
    margin-top: 40px;
  }

}
</style>

{#if visible}
<div id="popup-gallery"></div>

<div class="popup-modal">
<div class="popup-area">
  <div class="popup-window-wrap">
    <div class="popup-window" transition:fly={{y: 800, duration: 500 }}>
      <div class="popup-content">
        <div class="popup">
          <CloseButton close={closePopup}/>  

          <div class="content column">
            <div class="content-inner" bind:this={scrollContainer}>
              <slot {scrollContainer} />
            </div>            
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="popup-bg" on:click={closePopup} transition:fade={{duration: 500 }}></div>
</div>
</div>
{/if}